import React, { useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Card, CardBody, Container, Spinner } from 'reactstrap';
import useGet from '../../helpers/hooks/useGet';
import VegetablesList from './vegetables-list';

export const Vegetables = (props) => {
  const history = useHistory();
  const [vegetables, , vegetablesLoading] = useGet(
    '/vegetables?filter[order]=createdAt DESC',
    true
  );
  const handleEditVegetable = useCallback(
    (obj) => {
      history.push(`/system/vegetable-details/${obj.id}`);
    },
    [history]
  );
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Crops</h4>
            <Link to='/system/add-vegetable'>
              <Button
                color='primary'
                outline
                type='button'
                size='sm'
                className='waves-effect waves-light'
              >
                Add New Crop
                <i className='mdi mdi-plus align-middle ml-2'></i>
              </Button>
            </Link>
          </div>
          <Card>
            <CardBody>
              {vegetablesLoading ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <VegetablesList
                  vegetables={vegetables}
                  editVegetable={handleEditVegetable}
                />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};
